import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import { numberWithCommas } from "../../utils";

interface UnmatchedBannerProps {
  /** จำนวนใบที่ยังไม่จับคู่ร้าน มาจาก summary ของ API ไม่ใช่การนับแถวในหน้า */
  count: number;
  /** กำลังกรองเฉพาะใบที่ยังไม่จับคู่ร้านอยู่หรือไม่ */
  showingOnlyUnmatched: boolean;
  onToggleUnmatchedOnly: () => void;
}

/**
 * แถบแดง "ยังไม่จับคู่ร้าน N ใบ" ของ W7 ซึ่งอยู่เหนือตัวกรอง
 *
 * เป็นงานที่ค้างอยู่ที่สาขา ไม่ใช่ตัวบล็อก — PO เหล่านี้ถูกส่งมาแล้วและรอแค่คนกดยืนยันร้าน
 * ไม่แสดงอะไรเลยเมื่อไม่มีใบค้าง เพื่อไม่ให้แถบแดงกลายเป็นของประจำจอ
 */
export default function UnmatchedBanner({
  count,
  showingOnlyUnmatched,
  onToggleUnmatchedOnly,
}: UnmatchedBannerProps) {
  if (count === 0) return null;

  return (
    <Alert
      severity="error"
      sx={{ mb: 2 }}
      action={
        <Button color="inherit" size="small" onClick={onToggleUnmatchedOnly}>
          {showingOnlyUnmatched ? "ดูทั้งหมด" : "ดูเฉพาะที่ค้าง"}
        </Button>
      }
    >
      ยังไม่จับคู่ร้าน {numberWithCommas(count)} ใบ
    </Alert>
  );
}
